<!-- https://vcalendar.io/ -->
<template>
	<div>
		<b-input-group v-if="today">
	        <div class="input-group-prepend">
	            <div class="btn input-group-text" @click="dateToday" v-b-tooltip.hover="$t('global.date_jour')">
	                <font-awesome-icon :icon="['fal', 'calendar']" />
	            </div>
	        </div>

			<date-picker v-model="model" v-bind="pickerProps">
				<template v-slot="{ inputValue, inputEvents }">
					<input
						v-on="isBelowMd ? {} : inputEvents"
						@blur="onBlur(inputValue)"
						@click="openModal"
						type="text"
						class="form-control"
						:readonly="isBelowMd"
						:disabled="isDisabled"
						:value="inputValue"
					/>
				</template>
			</date-picker>
	    </b-input-group>

		<date-picker
			v-else
			v-model="model"
			v-bind="pickerProps"
		>
			<template v-slot="{ inputValue, inputEvents }">
				<input
					v-on="isBelowMd ? {} : inputEvents"
					@blur="onBlur(inputValue)"
					@click="openModal"
					type="text"
					class="form-control"
					:readonly="isBelowMd"
					:disabled="isDisabled"
					:value="inputValue"
				/>
			</template>
		</date-picker>

		<!-- Sur mobile le calendrier est présenté dans une modale plutôt qu'en popover : rendu au sein du
		     composant, le popover reste prisonnier des contextes d'empilement de la page (le contenu d'un
		     volet est plafonné par le z-index du conteneur Swiper) et se retrouve sous les bandeaux fixes,
		     alors que la modale est déplacée en fin de body. L'input passant en lecture seule, le clavier
		     virtuel ne réduit plus la fenêtre, et le calendrier pleine largeur offre des cibles tactiles
		     bien plus confortables. -->
		<b-modal v-if="isBelowMd" v-model="modal_show" :title="modalTitle" centered hide-footer>
			<date-picker
				:value="value"
				v-bind="pickerProps"
				is-expanded
				:class="{ 'e-datepicker-time': mode !== 'date' }"
				@input="onModalInput"
			/>
			<button v-if="mode !== 'date'" class="btn btn-block btn-primary mt-2" @click.prevent="modal_show = false">{{ $t('global.valider') }}</button>
		</b-modal>
	</div>
</template>


<script>
// https://vcalendar.io/attributes.html
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import Window from '@/mixins/Window.js'

export default {
	components: {
		'date-picker': DatePicker
	},
	name:'e-datepicker',
	mixins: [Window],
	props: {
		value:{
			type: Date,
			default: () => (new Date())
		},
		mode: {
			type: String,
			default: () => ('date')
		},
		popover: {
			type: Object,
			default: () => ({
				visibility: 'focus'
			})
		},
		disabled: {
			type: Boolean,
			default: () => ( false )
		},
		today: {
			type: Boolean,
			default: () => ( false )
		},
		minDate: {
			type: Date,
			default: null
		},
		maxDate: {
			type: Date,
			default: null
		}
	},
	data(){
        return {
            attributes: [{
				key: 'today',
				dates: new Date(),
				highlight: {
					color: 'pink',
					fillMode: 'outline',
				},
			}],
			masks: {},
			modal_show: false
        }
    },
    mounted() {
    	let date_config = JSON.parse(window.localStorage.getItem('format_date')) ?? 'd/m/Y'
    	date_config = date_config.replace('Y', 'YYYY').replace('y', 'YY').replace('d', 'DD').replace('m', 'MM')
    	this.masks = {L: date_config}
    },
	computed: {
		model:{
			get () {
				return this.value
			},
			set (val) {
				this.$emit('input', val)
			}
		},
		isDisabled(){
			return this.disabled
		},
		lang(){
			return this.$store.state.user.lang == 'code' ? 'fr' : this.$store.state.user.lang
		},
		// Le titre donne sa hauteur au bandeau de la modale : sans lui le bouton de fermeture, positionné
		// en absolu, déborde du bandeau et se retrouve rogné
		modalTitle(){
			return this.mode === 'date' ? this.$t('global.date') : this.$t('global.heure')
		},
		// Partagé par l'input de la page et par le calendrier de la modale, pour n'avoir qu'un seul endroit
		// où la configuration du composant est décrite
		pickerProps(){
			return {
				mode: this.mode,
				is24hr: true,
				locale: this.lang,
				color: 'pink',
				popover: this.popover,
				minDate: this.minDate,
				maxDate: this.maxDate,
				attributes: this.attributes,
				masks: this.masks
			}
		}
	},
	methods: {
		dateToday() {
			this.model = new Date()
		},
		onBlur(inputValue) {
			if (!inputValue && this.minDate && this.maxDate) {
				this.$emit("input", new Date())
			}
		},
		openModal() {
			if (this.isBelowMd) {
				this.modal_show = true
			}
		},
		onModalInput(val) {
			this.model = val
			// Choisir un jour vaut validation, alors que régler une heure demande plusieurs interactions
			if (this.mode === 'date') {
				this.modal_show = false
			}
		}
	}
}
</script>
